// extracted by mini-css-extract-plugin
export default {"tableInnerContainer":"Table_tableInnerContainer__vM6ct","thead":"Table_thead__nkVM5"};